import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-corner-right-bottom",
  "use": "icon-corner-right-bottom-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-corner-right-bottom\"><path d=\"M11 0v11H0\" stroke=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol